import React, { useEffect, useState } from "react";
import { Reveal } from "../components/Section";
import { WEDDING_CONFIG, getGuestName } from "../config";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_bride-entrance/artifacts/ell0bjqk_b3ad83826d1fc7036753ebb13465436c349f896d.webp";

export default function Hero({ weddingDate }) {
  const [opacity, setOpacity] = useState(1);
  const guestName = getGuestName();

  useEffect(() => {
    const handler = () => {
      const y = window.scrollY;
      setOpacity(Math.max(0.2, 1 - y / 600));
    };
    window.addEventListener("scroll", handler);
    return () => window.removeEventListener("scroll", handler);
  }, []);

  const formatted = weddingDate.toLocaleDateString("id-ID", {
    weekday: "long", day: "numeric", month: "long", year: "numeric",
  });

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center text-center px-6 overflow-hidden"
    >
      <div
        className="absolute inset-0"
        style={{
          opacity,
          backgroundImage: `linear-gradient(rgba(253,251,247,0.55), rgba(253,251,247,0.88)), url(${HERO_IMG})`,
          backgroundSize: "cover",
          backgroundPosition: "center 30%",
          filter: "saturate(0.9)",
        }}
      />

      <div className="relative z-10 max-w-2xl">
        {guestName && (
          <Reveal>
            <div className="mb-8 inline-block px-6 py-3 border border-gold/30 bg-white/40 backdrop-blur-sm" data-testid="guest-name-hero">
              <p className="text-[10px] tracking-[0.3em] uppercase text-gold mb-1">Kepada Yth.</p>
              <p className="font-serif italic text-lg text-charcoal">{guestName}</p>
            </div>
          </Reveal>
        )}
        <Reveal>
          <p className="text-xs tracking-[0.4em] uppercase text-gold mb-6">The Wedding of</p>
        </Reveal>
        <Reveal delay={0.2}>
          <h1 className="font-serif text-6xl md:text-8xl text-charcoal leading-none">
            {WEDDING_CONFIG.groom.firstName}
          </h1>
          <p className="font-script text-5xl md:text-6xl gold-text my-4">&</p>
          <h1 className="font-serif text-6xl md:text-8xl text-charcoal leading-none">
            {WEDDING_CONFIG.bride.firstName}
          </h1>
        </Reveal>
        <Reveal delay={0.5}>
          <div className="divider mt-10">
            <span className="text-xs tracking-[0.3em] uppercase text-charcoal/70">{formatted}</span>
          </div>
        </Reveal>
        <Reveal delay={0.7}>
          <p className="mt-8 font-serif italic text-lg md:text-xl text-charcoal/80 max-w-md mx-auto">
            {WEDDING_CONFIG.heroQuote}
          </p>
          <p className="mt-2 text-xs tracking-[0.25em] uppercase text-gold">{WEDDING_CONFIG.heroQuoteAttr}</p>
        </Reveal>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-charcoal/50">
        <span className="text-[10px] tracking-[0.3em] uppercase">Scroll</span>
        <div className="w-px h-12 bg-gradient-to-b from-gold to-transparent animate-pulse" />
      </div>
    </section>
  );
}
